import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import "./Login.css";
import AmazonLogo from "../../images/Amazon_logo.png";
import { connect } from "react-redux";
import { CreateNewUserSuccessAction } from "../../Reducers/AuthenticationReducer";
import { auth } from "../../firebase";

function Login({ createNewAccount }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();

  const signInHandler = (e) => {
    e.preventDefault();

    auth
      .signInWithEmailAndPassword(email, password)
      .then((response) => {
        createNewAccount(response);
        if (response) history.push("/");
      })
      .catch((e) => alert(e.message));
  };

  const registerHandler = (e) => {
    e.preventDefault();
    history.push("/signup");
  };

  return (
    <div className="login">
      <Link to="/">
        <img src={AmazonLogo} alt="Amazon logo" className="login__logo" />
      </Link>
      <div className="login__container">
        <h1>Log-in</h1>

        <form>
          <h5>E-mail</h5>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <h5>Password</h5>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button
            className="login__signInButton"
            onClick={signInHandler}
            type="submit"
          >
            Login In
          </button>
        </form>

        <p>
          By continuing, you agree to Flynn's Basket Conditions of Use and
          Privacy Notice.
        </p>
        <div className="login__newContent">
          <p className="login__newText">New To Application?</p>
        </div>
        <button className="login__registerButton" onClick={registerHandler}>
          Create new account
        </button>
      </div>
    </div>
  );
}

export default connect(null, {
  createNewAccount: CreateNewUserSuccessAction,
})(Login);
